import styled from 'styled-components'
import Card from 'react-bootstrap/Card'
import { Col, Button } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { H3 } from '../../../../typography'
import { weight } from '../../../../const/fonts'

export const CardTitleContainer = styled(Card.Title)`
  display: flex;
  justify-content: left;
  margin: 0;
`

export const FontAwesomeIconWrapper = styled(FontAwesomeIcon)`
  min-width: 3rem;
`

export const CardText = styled(H3)`
  margin-top: 1rem;
  margin-left: 1rem;
`

export const SubjectImage = styled(Card.Img)`
  width: 6rem;
`

export const ColumnWrapper = styled(Col)`
  margin: 1rem 0;
  display: flex;
  align-items: center;
  justify-content: center;

  &#session-details {
    flex-grow: 1;
  }
`

export const DetailsContainer = styled.div`
  margin-left: 1.5rem;
  min-width: 5rem;
`

export const JoinSessionButton = styled(Button)`
  font-weight: ${weight.bold};
  max-width: 15rem;
  margin: 0 auto;
  width: 12rem;
  min-height: 3rem;
  border-radius: 1rem;
  border: none;
  &,
  &:disabled {
    background-color: ${({ theme }) => theme.button.secondary};
  }
`

export const LightButton = styled(Button)`
  background: ${({ theme }) => theme.button.light};
  height: 45px;
  border: none;

  &:first-child {
    margin-right: 1rem;
  }

  &:hover,
  &:focus {
    transform: scale(1.1);
  }

  &:disabled {
    color: ${({ theme }) => theme.disabled};
  }
`
